import { DetailsRow, IDetailsRowProps } from '@fluentui/react';
export const _renderRow = (props :IDetailsRowProps , onClick?: () => void) => {
    if (props) {
        return (<div onClick={() => { if (onClick) { onClick() } }}>
            <DetailsRow {...props} />
        </div>);
    }
    return null;
};